import Droit from './droit';

/** @type {any} */
export const orders = {
	add:     {
		default: '*',
		sub:     {
			'*': {
				requires: [
					'org_kid',
					'role_kid',
					'kright',
				],
			},
		},
		type:    'none',
	},
	clean:   {
		restrict_admin: true,
		sub:            {
			all:        {},
			org:        {
				requires: ['org_kid'],
			},
			org_profil: {
				requires: ['org_kid'],
			},
			org_role:   {
				requires: ['org_kid'],
			},
		},
		type:           'select',
	},
	del:     {
		default: '*',
		sub:     {
			'*': {
				requires: [
					'org_kid',
					'role_kid',
				],
			},
		},
		type:    'none',
	},
	mod:     {
		sub:  {
			none: {
				requires: [
					'org_kid',
					'role_kid',
					'kright',
				],
			},
			add:  {
				requires: [
					'org_kid',
					'role_kid',
					'kright',
				],
			},
		},
		type: 'select',
	},
	process: {
		default:        'default',
		restrict_admin: true,
		sub:            {
			default: {},
		},
		type:           'text',
	},
};

export default class DroitCust extends Droit {
	/**
	 * @param {any} [droitcust]
	 */
	constructor(droitcust = null) {
		super(droitcust);

		/** @type {number} */
		this.index = droitcust ? droitcust.index : 0;

		/** @type {?('add' | 'clean' | 'del' | 'mod' | 'process')} */
		this.order = droitcust?.order;

		/** @type {string} */
		this.suborder = droitcust?.suborder || '*';

		this.org = {
			isa:           droitcust?.org?.isa || '0',
			kid:           droitcust?.org?.kid || '0',
			name:          droitcust?.org?.name || '',
			name_type_kid: droitcust?.org?.name_type_kid || 'K_NODE;STRING',
		};

		this.role = {
			isa:           droitcust?.role?.isa || '0',
			kid:           droitcust?.role?.kid || '0',
			name:          droitcust?.role?.name || '',
			name_type_kid: droitcust?.role?.name_type_kid || 'K_NODE;STRING',
		};
	}

	check() {
		let valid = true;
		if (this.order && ['add', 'mod'].includes(this.order) && this.kright === 0) {
			valid = false;
		}
		return valid;
	}

	export() {
		/** @type {any} */
		const droitcust = {
			index:    this.index,
			kid:      this.kid,
			kright:   null,
			order:    this.order,
			org_kid:  '0',
			role_kid: '0',
			suborder: this.suborder,
		};

		if (this.order && this.order in orders) {
			if (orders[this.order].sub[this.suborder]?.requires?.includes('kright')) {
				droitcust.kright = this.kright;
			}
			if (orders[this.order].sub[this.suborder]?.requires?.includes('role_kid')) {
				droitcust.role_kid = this.role.kid || '0';
			}
			if (orders[this.order].sub[this.suborder]?.requires?.includes('org_kid')) {
				droitcust.org_kid = this.org.kid || '0';
			}
		}

		return droitcust;
	}
}
